import { z } from 'zod';

export const GoogleAnalyticsEventsSchema = z.record(
  z.object({
    event_properties: z
      .object({
        event: z.string(),
        frontend_product_path_id: z.boolean().optional(),
        frontend_form_path_id: z.boolean().optional()
      })
      .catchall(z.string())
  })
);

export type GoogleAnalyticsEventsType = z.infer<
  typeof GoogleAnalyticsEventsSchema
>;
